export type GetMainRepresentationByArticleIdLayerLoadMode =
    (typeof GetMainRepresentationByArticleIdLayerLoadMode)[keyof typeof GetMainRepresentationByArticleIdLayerLoadMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMainRepresentationByArticleIdLayerLoadMode = {
    None: 'None',
    GraphicLayers: 'GraphicLayers',
    LogicLayers: 'LogicLayers',
    All: 'All'
} as const;
